import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import { PublicKey } from "@solana/web3.js";
import { useEffect, useState } from "react";
import { NodeInfoProps } from "../../interfaces";

const RaydiumLPDepositInfo = (props: NodeInfoProps) => {
  // TODO: put set/ unset into its own component
  return (
    <>
      <FormGroup>
        <FormControlLabel
          control={
            <Checkbox
              defaultChecked={props.input?.hasFarm ?? false}
              onChange={(e) => {
                props.updateInput({
                  hasFarm: e.target.checked,
                });
              }}
            />
          }
          label="Ensure that a farm exists"
        />
      </FormGroup>
    </>
  );
};

export default RaydiumLPDepositInfo;
